import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const COOKIE_CONSENT_KEY = 'vtf_cookie_consent';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const storedConsent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!storedConsent) {
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const saveConsent = (analytics) => {
        const settings = { technical: true, analytics, marketing: analytics };
        localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(settings));
        setIsVisible(false);
        if (analytics) {
            window.location.reload();
        }
    };

    if (!isVisible) return null;

    return (
        <div className="hidden md:flex fixed bottom-4 left-0 right-0 z-[1000] justify-center px-4 pointer-events-none transition-all duration-500 transform animate-in fade-in slide-in-from-bottom-2">
            <div className="bg-white/95 backdrop-blur-md border border-slate-200 shadow-xl rounded-full px-5 py-2.5 flex items-center gap-5 pointer-events-auto">
                <div className="flex items-center gap-2">
                    <CheckCircleFilled className="text-blue-500 text-lg" />
                    <span className="text-[13px] font-medium text-slate-700 whitespace-nowrap">
                        Chúng tôi sử dụng cookie. <a href="/chinh-sach-bao-mat" className="text-blue-600 font-bold hover:underline">Chi tiết</a>
                    </span>
                </div>
                
                <div className="flex items-center gap-1.5 border-l border-slate-100 pl-4">
                    <button 
                        onClick={() => saveConsent(false)}
                        className="text-[13px] font-bold text-slate-400 hover:text-slate-600 px-2 py-1 transition-colors"
                    >
                        Từ chối
                    </button>
                    <button 
                        onClick={() => saveConsent(true)}
                        className="text-[13px] font-extrabold text-blue-600 hover:text-blue-700 px-4 py-1.5 bg-blue-50 rounded-full transition-all"
                    >
                        Đồng ý
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
